import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  previewContainer: {
    flex: 2,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    borderLeft: `2px solid ${capitalDesignTokens.semanticColors.border.primary}`
  },

  iframeContainer: {
    position: 'relative',
    minHeight: '550px',
    height: '100%',
    flex: 1,
    marginTop: '16px',
    marginBottom: '16px',
    marginLeft: '16px',
    marginRight: '24px'
  },

  spinnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1.5,
    minHeight: '550px',
    justifyContent: 'center'
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    px: 3,
    py: 2,
    borderBottom: 1,
    borderColor: capitalDesignTokens.semanticColors.border.primary
  },

  headerTitle: {
    fontWeight: 600,
    fontSize: '16px',
    letterSpacing: '-0.25px',
    paddingBottom: 0
  },

  label: {
    paddingBottom: 0,
    color: 'capitalDesignTokens.semanticColors.text.secondary'
  },

  status: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1.5
  }
});
